import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Pill.module.scss';

export const pillColors = ['blue', 'green', 'gray', 'red', 'ivory'] as const;
export type PillColor = typeof pillColors[number];

export type PillProps = {
  children: ReactNode;
  color?: PillColor;
};

const Pill: FC<PillProps> = ({
  children,
  color = 'gray',
}) => (
  <div className={getClassNames(styles, 'root', classNames(color))}>
    {children}
  </div>
);

export default Pill;
